<script>

  import {mapActions, mapGetters} from 'vuex';
  import moduleUtils from '../ModuleUtils';
  import utils from '../FormBuilderUtils.js';
  import SgsRender from 'src/components/utils/sgs/SgsRender.vue';

  import sgsRenderUtils from 'src/components/utils/sgs/SgsUtils.js';
  import Pagination from 'src/components/utils/Pagination';

  import SgsRenderNotificationSuccess from 'src/components/utils/sgs/SgsRenderNotificationSuccess.vue';
  import SgsRenderNotificationError from 'src/components/utils/sgs/SgsRenderNotificationError.vue';

  export default {
    name: 'ModuleList',
    components: {
      SgsRender,
      Pagination,
      SgsRenderNotificationSuccess,
      SgsRenderNotificationError
    },
    props: [
      'fields', 'formIdentifier', 'parentId',
      'parentColumnName', 'title', 'filter',
      'showCreateButton', 'showEditIcon', 'showShowIcon',
      'businessRulesBeforeCrudViewList'
    ],
    data: function() {
      return {
        rules: {},
        state: {
          stateName: "",
          uri: "",
          filter: {
            itemsPerPage: 25,
            _showFilter: true
          },
          list: [],
          pagination: {},
          submitted: false,
          clickFromButton: false,
          excludeApi: true
        },
        localList: [],
        notificationError: null,
        notificationSuccess: null,
        formIdentifierModal: {}
      }
    },
    computed: {
      ...mapGetters([
        'retrieveState',
        'list',
        'pagination',
        'showBottomPagination'
      ]),
      _fields: function() {

        var ret = [];

        if (this.fields) {
          _.orderBy(this.fields, ['name'], ['asc']).map(it => {
            ret.push(it);
          });
        }

        return ret;
      },
      _resultDesign: function() {
        var ret =[];

        if(this.filter && this.filter.resultDesign && this.filter.resultDesign.length) {
          _.orderBy(this.filter.resultDesign, ['position'], ['asc']).map(it => {

            let visible = true;

            if (this.$i18n.locale == 'pt' && it.visibleToPt != undefined) {
              visible = it.visibleToPt;
            } else if (this.$i18n.locale == 'es' && it.visibleToEs != undefined) {
              visible = it.visibleToEs;
            } else if (this.$i18n.locale == 'en' && it.visibleToEn != undefined) {
              visible = it.visibleToEn;
            }

            if (visible) {
              ret.push(
                _.find(this._fields, { 'id': it.id})
              );
            }
          });
        } else {
          let itemsToExcluded = [
            'textArea', 'header', 'collapse',
            'password', 'file', 'hidden', 'image', 'grid', 'inputCSV', 'textEditor'
          ]

          this._fields.map(it => {

            if (ret.length < 5 && it.persistent && !(itemsToExcluded.indexOf(it.type) > -1)) {
              ret.push(it);
            }
          });
        }

        return ret;
      },
      _resultActions: function() {
        if(this.filter && this.filter.resultActions) {
          return this.filter.resultActions;
        }
        return [];
      },
      widthIcons: function() {
        let iconWidth = 40;
        let width = (this._resultActions.length * iconWidth);
        if (this.showEditIcon) {
          width += iconWidth;
        }
        if (this.showShowIcon) {
          width += iconWidth;
        }
        return width + "px";
      },
      filterRows: function() {
        if (this.filter && this.filter.filterDesign) {
          return this.filter.filterDesign.rows;
        }
        return [];
      },
      filterFields: function() {
        if (this.filter && this.filter.filterDesign) {
          return this.filter.filterDesign.fields;
        }
        return [];
      }
    },
    mounted: function() {

      this.loadState().then(response => {

        if (this.filterFields.length > 0) {
          this.filterFields.map(item => {
            this.$set(this.state.filter, item.columnName, '');
          });
        }

        if(this.businessRulesBeforeCrudViewList) {
          this.callBusinessRule(this.businessRulesBeforeCrudViewList, this.state.filter);
        }
      });
    },
    watch: {
      'formIdentifier': function(newValue, oldValue) {
        if (!(newValue.formId == oldValue.formId)) {
          this.loadState();
        }
      },
      'state.filter._showFilter': function(newValue, oldValue) {
        this._doSearch();
      },
      'filter': function(newValue) {
        if (newValue && newValue.filterDesign) {
          newValue.filterDesign.fields.map(item => {
            this.$set(this.state.filter, item.columnName, '');
          });
          if(this.businessRulesBeforeCrudViewList) {
            this.callBusinessRule(this.businessRulesBeforeCrudViewList, this.state.filter);
          }
        }
      },

    },
    methods: {
      ...mapActions([
        'showLoader',
        'hideLoader',
        'doSearch',
        'setPage',
        'setItemsPerPage',
        'setNewObjectStateCommit'
      ]),
      loadState: function() {

        this.localList = [];
        let stateName = this.formIdentifier.formId;

        if (this.parentId) {
          stateName = stateName + '_' + this.parentId;
          this.$set(this.state.filter, 'parentId', this.parentId);
        }

        return Promise.resolve().then(() => {
          if (this.retrieveState(stateName) === undefined) {
            Promise.resolve().then(() => {
              this.state.stateName = stateName;
              this.state.uri = moduleUtils.resolveFormUri(this.formIdentifier) + "/rows";
              if (this.filterRows.length === 0) {
                this.state.filter._showFilter = false;
              }
            }).then(() => {
              this.setNewObjectStateCommit(Object.assign({}, this.state));
            });
          } else {
            Promise.resolve().then(() => {

              return this.retrieveState(stateName);

            }).then((response) => {

              this.state = response;

            }).then(() => {

              if(this.state.filter.currentPage > 1) {
               this._setPage(this.state.filter.currentPage);
              } else {

                if(this.state.submitted) {
                  this._doSearch();
                }
              }
            });
          }
        });
      },
      create: function() {
        this.$emit('changeModuleActive', 'form');
      },
      edit: function(row) {
        this.$emit('changeModuleActive', 'form', row.id);
      },
      show: function (row) {
        this.$emit('changeModuleActive', 'show', row.id);
      },
      _doSearch: function() {

        this.state.clickFromButton = true;

        if (this.state.filter._showFilter) {
          this.$refs["instance"].validate((valid) => {
            if (valid) {
              this.state.filter.currentPage = 1;
              this.doSearch(this.state).then(() => {
                this.resolveLocalList();
              });
            } else {
              console.log('error submit!!');
            }
          });
        } else {
          this.state.filter.currentPage = 1;
          this.doSearch(this.state).then(() => {
            this.resolveLocalList();
          });
        }
      },
      resolveLocalList: function() {
        this.localList = this.list(this.state);
      },
      getField: function(id, list) {
        return utils.findField(id, list);
      },
      getFilterField: function(id) {
        return this.getField(id, this.filterFields);
      },
      getFormField: function(id) {
        return this.getField(id, this._fields);
      },
      getFormFieldLabel: function(field) {

        if (field == undefined) {
          return "";
        }

        let labelPt = field.labelPt;
        let labelEs = field.labelEs;
        let labelEn = field.labelEn;

        if (this.$i18n.locale == 'es' && field.labelEs) {
          return field.labelEs
        } else if (this.$i18n.locale == 'en' && field.labelEn) {
          return field.labelEn
        }

        return field.labelPt;
      },
      getTableHeaderLabel: function(id) {
        let field = this.getField(id, this._fields);

        let labelPt = field.labelPt;
        let labelEs = field.labelEs;
        let labelEn = field.labelEn;

        if (this.state.filter._config) {
          let newHeader = this.state.filter._config[field.columnName];
          if (newHeader) {

            if (newHeader.labelPt) {
              labelPt = newHeader.labelPt;
            }
            if (newHeader.labelPt) {
              labelEs = newHeader.labelEs;
            }
            if (newHeader.labelPt) {
              labelEn = newHeader.labelEn;
            }
          }
        }

        if (this.$i18n.locale == 'es' && field.labelEs) {
          return field.labelEs
        } else if (this.$i18n.locale == 'en' && field.labelEn) {
          return field.labelEn
        }

        return field.labelPt;
      },
      updateField: function(fieldName, fieldValue) {
        this.$set(this.state.filter, fieldName, fieldValue);
        //this.state.filter[fieldName] = fieldValue;
      },
      getColumnName: function(id) {

        var el = this.getFilterField(id)
        if (el != undefined) {
          return el.columnName;
        }

        return "";
      },
      formatField: function(value, type) {
        return sgsRenderUtils.formatField(value, type);
      },
      _setItemsPerPage: function (val) {
        this.state.filter.itemsPerPage = val;
        this.setItemsPerPage(this.state).then(() => {
          this.resolveLocalList();
        });
      },
      _setPage: function (val) {
        this.state.filter.currentPage = val;
        this.setPage(this.state).then(() => {
          this.resolveLocalList();
        });
      },
      callBusinessRule: function(businessRuleId, instance) {

        this.showLoader();

        moduleUtils.callBusinessRule(this.formIdentifier, instance, businessRuleId)
          .then(response => {
            this.hideLoader();

            _.forOwn(response.body.instance, (value, key) => {
              this.$set(instance, key, value);
            });

            this.notificationError = response.body.notificationError;
            this.notificationSuccess = response.body.notificationSuccess;

          })
      },
      callBusinessRuleFilter: function (businessRuleId) {
        this.callBusinessRule(businessRuleId, this.state.filter);
      },
      actionButton: function(button, fieldsDataRow) {
        if (button.type === 'ACTION' || !button.type) {
          this.callBusinessRule(button.businessRules.id, fieldsDataRow);
        } else if (button.type === 'REPORT') {
          this.doGenerateReport(fieldsDataRow, button.form.id);
        } else if (button.type === 'LINK') {
          this.$emit('actionLinkSelected', button.form.id, fieldsDataRow);
        }
      },
      returnNewFormIdentifier: function(formId) {
        let formIdentifier = Object.assign({}, this.formIdentifier);
        formIdentifier.formId = formId;

        return formIdentifier;
      },
      doGenerateReport: function (fieldsDataRow, formId) {

        this.$refs["instance"].validate((valid) => {
          if (valid) {

            this.showLoader();

            moduleUtils.moduleFormGenerateReport(this.returnNewFormIdentifier(formId), fieldsDataRow, true)
              .then(response => {

                this.hideLoader();

                if (response.body) {
                  this.notificationError = response.body.notificationError;
                  this.notificationSuccess = response.body.notificationSuccess;
                }
                /*
                if (response.meta.code == 400) {

                  this.$notify({
                    title: 'Error',
                    message: response.body.instance.error,
                    type: 'error'
                  });
                }
                */
                if (response.meta.code == 400) {

                  _.forOwn(response.body.instance, (value, key) => {
                    this.$set(this.instance, key, value);
                  });

                } else if (response.meta.code == 500) {

                  this.$notify({
                    title: 'Error',
                    message: this.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
                    type: 'error'
                  });
                }
              })
          } else {
            console.log('error submit!!');
          }
        });
      },
      renderIcon: function(icon) {
        return ("glyphicon glyphicon-" + icon);
      },
      returnBackgroundColor: function(backgroundColor) {
        if (backgroundColor) {
          return "background-color: " + backgroundColor + "; color: white;";
        }
        return "";
      },
      getAttrConfig: function(instance, columnName) {
        if (instance != undefined && instance._config != undefined && columnName != undefined) {
          return instance._config[columnName];
        }
      }
    }
  }

</script>

<template>
  <div>
    <SgsRenderNotificationSuccess v-model="notificationSuccess"/>
    <SgsRenderNotificationError v-model="notificationError"/>

    <div class="page-header">
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <h2>{{ title }}</h2>
        </div>
        <div class="col-md-6 col-sm-12" style="margin-top: 11px;">
          <div class="pull-right">
            <el-button size="small" type="primary" @click.prevent="create()" v-if="showCreateButton">
              <i class="glyphicon glyphicon-plus" aria-hidden="true"/>
              {{$t('newA')}} {{ title }}
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <el-collapse v-model="collapseActiveName" v-if="state.filter._showFilter">
      <el-collapse-item :title="$t('filters')">
        <div>
          <el-form label-position="top" :rules="rules" :model="state.filter" ref="instance">

            <div class="row" v-for="(row, index) in filterRows">

              <div v-for="(col, index) in row.cols" :class="'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width">
                <template v-for="(field, index) in col.fields">
                  <SgsRender
                    :type="field.type"
                    moduleType="form"
                    :attr="getFilterField(field.id)"
                    :attrConfig="getAttrConfig(state.filter, getColumnName(field.id))"
                    @input="updateField"
                    :rules="rules"
                    @callBusinessRule="callBusinessRuleFilter"
                    :formIdentifier="formIdentifier"
                    :fieldValue="state.filter[getColumnName(field.id)]"
                    :instance="state.filter"
                    v-show="!getFilterField(field.id).hideOnFilter"
                  />
                </template>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <el-button size="small" type="primary" @click.prevent="_doSearch()">
                  <i class="glyphicon glyphicon-search" aria-hidden="true"/>
                  {{$t("search")}}
                </el-button>
              </div>
            </div>

          </el-form>

        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="panel" v-if="localList.length">
      <div class="panel-body">

        <div class="row margin-bottom-15">
          <div class="col-md-12">
            <Pagination
              :pagination="pagination(state)"
              @change-page="_setPage"
              @change-items-per-page="_setItemsPerPage" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">

              <table class="table table-striped big-table">

                <colgroup>
                  <col :width="widthIcons">
                  <col>
                </colgroup>

                <thead>
                <tr>
                  <th v-if="showShowIcon || showEditIcon || _resultActions.length > 0">{{$t('actions')}}</th>
                  <th v-for="field in _resultDesign">
                    <span>{{getTableHeaderLabel(field.id)}}</span>
                  </th>
                </tr>
                </thead>

                <tbody>

                <tr v-for="fieldsDataRow in localList" v-if="localList.length">

                  <td v-if="showShowIcon || showEditIcon || _resultActions.length > 0" class="buttonIcon">
                    <el-button
                      :id="'show_' + fieldsDataRow.id"
                      type="primary"
                      size="mini"
                      v-if="showShowIcon"
                      @click.prevent="show(fieldsDataRow)">
                      <i class="glyphicon glyphicon-file"></i>
                    </el-button>

                    <el-button
                      :id="'edit_' + fieldsDataRow.id"
                      type="primary"
                      size="mini"
                      v-if="showEditIcon"
                      @click.prevent="edit(fieldsDataRow)">
                      <i class="glyphicon glyphicon-edit"></i>
                    </el-button>

                    <el-button
                      v-for="button in _resultActions"
                      v-if="_resultActions.length > 0"
                      size="mini"
                      :style="returnBackgroundColor(button.backgroundColor)"
                      :title="button.hintPt"
                      @click.prevent="actionButton(button, fieldsDataRow)">
                      <i :class="renderIcon(button.icon)"/>
                    </el-button>
                  </td>

                  <td v-for="field in _resultDesign" :data-th="getFormFieldLabel(field)" >
                    <SgsRender
                      :type="field.type"
                      moduleType="list"
                      :attr="field"
                      :fieldValue="fieldsDataRow[getFormField(field.id).columnName]"
                      :formIdentifier="formIdentifier"
                    />
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>

        <div class="row margin-top-15" v-show="showBottomPagination(state)">
          <div class="col-md-12">
            <Pagination
              :pagination="pagination(state)"
              @change-page="_setPage"
              @change-items-per-page="_setItemsPerPage"/>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
  @media(max-width: 992px) {
  .big-table th {
    display: none;
  }
  .big-table td {
    display: grid;
    border: 0px solid #000!important;
  }
  .big-table tr {
    display: block;
    margin-bottom: 20px;
    padding-bottom: 20px;
  }
  .big-table td.buttonIcon{
    display: block;
  }
  .big-table td.buttonIcon:before {
    content: attr(data-th) "";
    width: 0.0em;
    display: inline-block;
  }
  .big-table td:before {
    content: attr(data-th) ": ";
    font-weight: bold;
    width: 10.5em;
    display: inline-block;
  }
  .big-table td div {
    display: inline-block;
  }
  .big-table td.action-buttons {
    display: inline;
  }
}

</style>



// WEBPACK FOOTER //
// ModuleList.vue?0ee6b413